const GlobalRouter = {};

let router;

GlobalRouter.init = function(pRouter){
    router = pRouter;
    // _obj.state = store.state;
}

GlobalRouter.push = function(path){
    router.push({ path: path });
}



export default GlobalRouter;
